export default __webpack_public_path__ + "static/media/NextArrow.beff41b4.svg";